import React from 'react';

const StatsCard = ({ icon, title, value, color }) => {
  return (
    <div className="bg-[#1E1E1E] border border-white/10 rounded-xl p-6 hover:border-[#00BFA6]/30 transition-all" data-testid={`stats-card-${title.toLowerCase().replace(/\s/g, '-')}`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="text-sm text-gray-400 mb-2">{title}</div>
          <div className="font-mono text-3xl font-bold" style={{ color }}>
            {value}
          </div>
        </div>
        <div style={{ color }} className="opacity-70">
          {icon}
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
